import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "text-gray-400 italic"
}
const _hoisted_4 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_5 = {
  key: 2,
  class: "flex flex-wrap gap-1"
}
const _hoisted_6 = {
  key: 3,
  class: "text-gray-400"
}
const _hoisted_7 = { class: "ml-auto pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }
const _hoisted_8 = { class: "overflow-hidden rounded-lg border border-gray-300 bg-white shadow-2xl" }
const _hoisted_9 = {
  key: 0,
  class: "flex border-b p-2 border-gray-300"
}
const _hoisted_10 = {
  class: "max-h-60 p-2 overflow-y-auto overflow-hidden",
  ref: "options"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 2,
  class: "flex items-center gap-x-2 text-gray-400 ml-auto"
}
const _hoisted_15 = {
  key: 1,
  class: "italic"
}
const _hoisted_16 = {
  key: 1,
  class: "p-2 italic text-gray-400"
}

import { Badge } from '@component/Badge'
import { FormInput } from '@component/Form'
import { Loader } from '@component/Miscellaneous'
import type { ComponentPublicInstance } from 'vue'
import { vOnClickOutside } from '@vueuse/components'
import type { FormSelectOption } from '@/interfaces'
import { ChevronDownIcon } from '@heroicons/vue/24/solid'
import { ref, nextTick, watch, useTemplateRef, unref } from 'vue'
import { ListTransition, FadeTransition } from '@component/Transitions'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectBase',
  props: /*@__PURE__*/_mergeModels({
    placeholder: {},
    isLoading: { type: Boolean },
    isDisabled: { type: Boolean },
    isMultiple: { type: Boolean },
    isSearchable: { type: Boolean },
    options: {},
    selected: {}
  }, {
    "searchQuery": {
  default: ""
},
    "searchQueryModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["open", "search", "select", "deselect"], ["update:searchQuery"]),
  setup(__props: any, { emit: __emit }) {

const isOpen = ref<boolean>(false);
const optionsRef = useTemplateRef<HTMLElement>("options");
const searchInputRef = useTemplateRef<ComponentPublicInstance<typeof FormInput>>("searchInput");

const modelSearch = _useModel<string>(__props, "searchQuery");

const emit = __emit;



function deselect(id: string|number|null): void {
  emit("deselect", id);
}

function select(id: string|number|null): void {
  emit("select", id);

  modelSearch.value = "";

  !__props.isMultiple && (isOpen.value = false);

  nextTick(() => unref(searchInputRef)?.$el.focus());
}

function toggle(): void {
  if (__props.isDisabled) return;

  isOpen.value = !isOpen.value;
}

function close(): void {
  isOpen.value = false;
}

watch(modelSearch, searchQuery => emit("search", searchQuery));

watch(isOpen, isOpen => {
  if (!isOpen) return;

  nextTick(() => unref(searchInputRef)?.$el.focus());

  nextTick(() => {
    const options = unref(optionsRef);

    if (!options) return;

    options.scrollTo({ top: 0, behavior: "instant" });
  });

  emit("open");
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      disabled: _ctx.isDisabled,
      onClick: toggle,
      class: "block text-left w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 sm:text-sm/6 disabled:bg-gray-200 disabled:hover:cursor-not-allowed"
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Aan het laden..."))
        : (!_ctx.isMultiple && _ctx.selected[0])
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.selected[0].label), 1))
          : (_ctx.isMultiple && _ctx.selected[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected, (option) => {
                  return (_openBlock(), _createBlock(_unref(Badge), {
                    label: option.label,
                    "is-closeable": "",
                    onClose: ($event: any) => (deselect(option.value)),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["label", "onClose"]))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.placeholder), 1)),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Loader), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
              key: 1,
              class: _normalizeClass(["h-5 w-5 text-gray-500 transition-transform", { '-rotate-180': isOpen.value }])
            }, null, 8, ["class"]))
      ])
    ], 8, _hoisted_2),
    _createVNode(_unref(FadeTransition), null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "absolute z-50 w-full mt-1",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.isSearchable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(FormInput), {
                    modelValue: modelSearch.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelSearch).value = $event)),
                    placeholder: "Zoek op item...",
                    ref: "searchInput"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.options.length)
                ? (_openBlock(), _createBlock(_unref(ListTransition), {
                    key: 0,
                    "is-back": ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: option.label,
                          onClick: ($event: any) => (select(option.value)),
                          class: "relative select-none flex items-center gap-x-2 p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
                        }, [
                          (option.icon)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(option.icon), {
                                key: 0,
                                class: "size-6"
                              }))
                            : (option.image)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  alt: "",
                                  class: "size-6 rounded",
                                  src: option.image
                                }, null, 8, _hoisted_12))
                              : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: "text-sm leading-6 font-medium text-gray-900",
                            innerHTML: option.label
                          }, null, 8, _hoisted_13),
                          (option.command || option.commandIcon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (option.commandIcon)
                                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(option.commandIcon), {
                                      key: 0,
                                      class: "size-6"
                                    }))
                                  : _createCommentVNode("", true),
                                (option.command)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(option.command), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_11))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.options.length && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Er zijn geen items beschikbaar..."))
                : _createCommentVNode("", true)
            ], 512)
          ])
        ], 512), [
          [_vShow, isOpen.value]
        ])
      ]),
      _: 1
    })
  ])), [
    [_unref(vOnClickOutside), close]
  ])
}
}

})